import { createActionsFor } from '@modules/crud/createCrudModule';


import reducer from './note.reducer';

export const noteDefaults = {
	content: '',
};

export default {
  actions: createActionsFor('note'),
  reducer,
}

// TODO: register modified reducer here



// WEBPACK FOOTER //
// ./src/modules/note/note.module.js